// TODO: Load all images modal opened (or start loading after page load complete for a bit)
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slider = this.querySelector('[data-product-media-slider]');
        this.list = this.querySelector('[data-product-media-list]');
        this.overlay = null;
        this.handleKeyPress = throttle(this.onKeyPress.bind(this), 100);
        this.handleSliderNavigation = this.onSliderNavigation.bind(this);
        this.handleConnectedSliderNavigation = this.onConnectedSliderNavigation.bind(this);
        this.debouncedOnSlideChanged = debounce(
          this.onSlideChanged.bind(this),
          SLIDE_CHANGE_DEBOUNCE_TIMER
        );
        this.debouncedConnectedSlideChanged = debounce(
          this.onConnectedSlideChanged.bind(this),
          SLIDE_CHANGE_DEBOUNCE_TIMER
        );

        this.setActiveItem(this.list.firstElementChild);
      }

      connectedCallback() {
        super.connectedCallback();
        this.connectedSlider = Array.from(
          document.querySelectorAll(
            `[data-product-media-slider="${this.slider.dataset.productMediaSlider}"]`
          )
        ).find(slider => slider !== this.slider);

        this.slider.addEventListener('slideChanged', this.debouncedOnSlideChanged);
        this.connectedSlider?.addEventListener('slideChanged', this.debouncedConnectedSlideChanged);
        this.slider.addEventListener('navigate', this.handleSliderNavigation);
        this.connectedSlider?.addEventListener('navigate', this.handleConnectedSliderNavigation);
        this.addEventListener('keydown', this.handleKeyPress);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.slider.removeEventListener('slideChanged', this.debouncedOnSlideChanged);
        this.connectedSlider?.removeEventListener(
          'slideChanged',
          this.debouncedConnectedSlideChanged
        );
        this.slider.removeEventListener('navigate', this.handleSliderNavigation);
        this.connectedSlider?.removeEventListener('navigate', this.handleConnectedSliderNavigation);
        this.removeEventListener('keydown', this.handleKeyPress);
      }

      hide() {
        if (this.slider.isNavigating || this.timeline.isActive()) return;

        super.hide();
      }

      // TODO: Trigger isNavigating for "swipes" (on all sliders)
      show(opener, openerMedia) {
        if (this.connectedSlider.isNavigating) return;

        this.connectedMedia = openerMedia;

        this.showActiveMedia(opener);

        super.show(opener);
      }

      onSlideChanged(e) {
        this.setActiveItems(e.detail.currentElement);

        if (!this.isOpen()) return;

        this.playActiveMedia();
        this.connectedSlider?.goToSlide(e.detail.currentPage - 1, { jump: true });
      }

      onConnectedSlideChanged(e) {
        if (this.isOpen()) return;

        this.slider.goToSlide(e.detail.currentPage - 1, { jump: true });
      }

      onSliderNavigation(e) {
        this.setActiveItems(e.detail.currentElement);

        if (!this.isOpen()) return;

        this.connectedSlider.goToSlide(e.detail.destinationPage - 1, { jump: true });
      }

      onConnectedSliderNavigation(e) {
        if (this.isOpen()) return;

        this.slider.goToSlide(e.detail.destinationPage - 1, { jump: true });
      }

      // TODO: Test this when swapping variant media
      // TODO: Test this with models
      scaleUpMedia() {
        this.activeMedia.style.display = 'none';
        this.flipState = Flip.getState([this.connectedMedia, this.activeMedia]);

        this.setAttribute('open', true);
        this.activeMedia.style.display = 'block';
        this.connectedMedia.style.display = 'none';

        Flip.from(this.flipState, {
          targets: this.activeMedia,
          duration: 0.5,
          ease: 'power2.inOut',
          absolute: true,
          simple: true,
          scale: !this.activeVideo,
          onStart: () => {
            this.timeline.play();
          },
          onComplete: () => {
            gsap.set(this.connectedMedia, { clearProps: 'all' });
            gsap.set(this.activeMedia, { clearProps: 'all' });

            this.playActiveMedia();
          },
        });
      }

      scaleDownMedia() {
        Flip.fit(this.activeMedia, this.connectedMedia, {
          duration: 0.5,
          ease: 'power2.inOut',
          simple: true,
          // scale: !this.activeVideo,
          onStart: () => {
            this.timeline.reverse();
            this.connectedMedia.style.display = 'none';
          },
          onComplete: () => {
            this.playConnectedMedia();
          },
        });
      }

      updateAttributes(open = true, stateChange = false) {
        super.updateAttributes(open, stateChange);

        if (!open) {
          gsap.set(this.connectedMedia, { clearProps: 'all' });
          gsap.set(this.activeMedia, { clearProps: 'all' });
        }
      }

      // TODO: Test with non-image media
      buildTimeline() {
        if (this.timeline) this.timeline.kill();

        this.timeline = gsap
          .timeline({
            paused: true,
            onStart: this.handleTimelineStart,
            onReverseComplete: this.handleTimelineReverseComplete,
          })
          .from(this.firstElementChild, {
            backgroundColor: 'transparent',
            duration: 0.5,
            ease: 'power2.inOut',
          })
          .from(
            this.querySelectorAll('[data-controls]'),
            {
              autoAlpha: 0,
              duration: 0.5,
              ease: 'power2.inOut',
            },
            0
          );

        if (this.isOpen()) {
          this.timeline.progress(1);
        }
      }

      // TODO: Clean up all video stuff now that actual element is target
      matchVideoProgress(open = true) {
        const master = open ? this.connectedMedia : this.activeMedia;
        const slave = open ? this.activeMedia : this.connectedMedia;

        // const currentTime = master.querySelector('video')?.currentTime;
        const currentTime = master.currentTime;

        if (currentTime) {
          // slave.querySelector('video').currentTime = currentTime;
          slave.currentTime = currentTime;
        }
      }

      animate(open = true) {
        // this.activeVideo = this.activeMedia.nodeName == 'DEFERRED-MEDIA';
        this.activeVideo = ['DEFERRED-MEDIA', 'VIDEO', 'IFRAME'].includes(
          this.activeMedia.nodeName
        );

        if (this.activeVideo) {
          window.pauseAllMedia();

          // if (this.connectedMedia.dataset.productVideo !== undefined) {
          // TODO: Remove `data-product-video` attr if video targeting not reverted
          if (this.connectedMedia.nodeName == 'VIDEO') {
            this.matchVideoProgress(open);
          }
        }

        setTimeout(
          () => {
            if (open) {
              this.zoomControls.forEach(zoom => zoom.reset());
              this.scaleUpMedia();
            } else {
              const zoom = this.zoomControls[0];

              if (zoom && zoom.level > zoom.levelMin) {
                const zoomUnsubscriber = subscribe(PUB_SUB_EVENTS.zoomChange, ({ data }) => {
                  const {
                    zoomLevel: { min, current },
                  } = data;

                  // TODO: Consider altering zoom out easing (ease in) and close easing (ease out) to smooth transition
                  if (current === min) {
                    this.scaleDownMedia();
                    zoomUnsubscriber();
                  }
                });

                this.zoomControls.forEach(zoom => zoom.reset());
              } else {
                this.scaleDownMedia();
              }
              this.zoomControls.forEach(zoom => {
                zoom.reset();
              });
            }
          },
          this.activeVideo ? 100 : 0
        );
      }

      onKeyPress(e) {
        if (!this.isOpen()) return;

        switch (e.key) {
          case 'ArrowLeft':
            this.slider.step(-1);
            break;
          case 'ArrowRight':
            this.slider.step(1);
            break;
        }
      }

      setActiveItem(item) {
        this.activeItem = item;
        this.activeMedia =
          this.activeItem.querySelector('[data-flip-id]') || this.activeItem.firstElementChild;
        this.activeIndex = Array.from(this.list.children).indexOf(this.activeItem);
      }

      setActiveItems(element) {
        if (element === this.activeItem) return;

        this.setActiveItem(element);
        const connectedActiveItem = this.connectedSlider.querySelector(
          `[data-media-id="${this.dataset.sectionId}-${this.activeItem.dataset.mediaId}"]`
        );

        if (!connectedActiveItem) return;

        this.connectedMedia = connectedActiveItem.querySelector('[data-flip-id]');
      }

      showActiveMedia(opener) {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${opener.getAttribute('data-media-id')}"]) > *`
        ).forEach(element => {
          element.classList.remove('active');
        });

        this.setActiveItem(
          this.querySelector(`[data-media-id="${opener.getAttribute('data-media-id')}"]`)
        );

        // const activeMediaTemplate = this.activeMedia.querySelector('template');
        // const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.activeMedia.classList.add('active');
        this.slider.goToSlide(this.activeIndex, { jump: true });

        // TODO: Test this once videos can be opened in modal.
        // if (this.activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent) {
        //   this.playActiveMedia();
        // }
      }

      playActiveMedia() {
        this.playMedia(this.activeMedia);
        // window.pauseAllMedia();
        // const deferredMedia = this.activeMedia.closest('.deferred-media');
        // if (deferredMedia.nodeName == 'DEFERRED-MEDIA') deferredMedia.loadContent(false);
      }

      playConnectedMedia() {
        this.playMedia(this.connectedMedia);

        // window.pauseAllMedia();
        // const deferredMedia = this.connectedMedia.closest('.deferred-media');
        // if (deferredMedia.nodeName == 'DEFERRED-MEDIA')
        //   deferredMedia.loadContent(false);
      }

      playMedia(media) {
        window.pauseAllMedia();

        if (media.nodeName == 'DEFERRED-MEDIA') {
          media.loadContent(false);
        } else if (media.nodeName == 'VIDEO') {
          media.play();
        }
      }
    }
  );

  customElements.define(
    'product-modal-opener',
    class ProductModalOpener extends ModalOpener {
      constructor() {
        super();
        this.button = this.querySelector('[data-modal-open]');
        // this.media = this.querySelector('[data-flip-id]');
      }

      open() {
        this.media ??= this.querySelector('[data-flip-id]');
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(this.button, this.media);
      }
    }
  );
}
